'use client'
import styled from "styled-components";
import {Accordion, Col, Tab, Tabs} from "react-bootstrap";
import {BsChevronDown} from "react-icons/bs";
import React, {useState} from "react";
import {hover, softWhite, text, white} from "@/styles/globalStyleVars";
import {components} from "react-select";
import ThemeContainer from "@/components/common/theme/container";
import SelectField from "@/components/common/SelectField";
import reactHtmlParser from "react-html-parser";
import Link from "next/link";

const Address = ({data, callContactForm, loading, formData, formDataFailed, clearContact}) => {


    let countryOptions = [];
    if (data?.data?.list && data?.data?.list.length > 0) {
        countryOptions = data?.data?.list.map(e => ({
            value: e?.page_data?.slug,
            label: e?.page_data?.subtitle
        }));
    }
    const [selectedValue, setSelectedValue] = useState(countryOptions?.[0]?.value);

    const handleClick = ((e) => {
        setSelectedValue(`${e?.value}`)
    })




    return (
        <StyledAddress className='address '>

            <ThemeContainer containerClass={'p-0'} fluid>
                <div className="address-filter__mobile">
                   <SelectField onChange={handleClick} selectedValue={selectedValue} selection={countryOptions} placeholder={'Select Country'} />
                </div>
            </ThemeContainer>

            <ThemeContainer colProps={{md: 12}}>
                {
                    data?.data?.list && data?.data?.list?.length > 0 &&
                    <Tabs
                        activeKey={selectedValue}
                        defaultActiveKey={selectedValue}
                        onSelect={(k) => {
                            setSelectedValue(k);
                        }}
                        id="uncontrolled-tab-example"
                        className="mb-3 address-cat-list"
                    >
                        {
                            data?.data?.list && data?.data?.list?.length > 0 &&
                            data?.data?.list?.map((e,index) => {
                                return(
                                    <Tab eventKey={e?.page_data?.slug} key={index} title={e?.page_data?.subtitle}>


                                        {
                                            e?.sections && e?.sections?.length > 0 &&
                                            <Accordion defaultActiveKey="0">
                                                {
                                                    e?.sections && e?.sections?.length > 0 &&
                                                    e?.sections?.map((i,i_index) => {
                                                        const phoneNumbers = i?.section_data?.short_desc.split(", ");
                                                        return(
                                                            <Accordion.Item key={i_index} eventKey={`${i_index}`}>
                                                                <Accordion.Header>
                                                                    <div className="contact-numbers d-flex">

                                                                        <Col className="pl-0" sm={3}>
                                                                            <h4>{reactHtmlParser(i?.section_data?.title)}</h4>
                                                                        </Col>

                                                                        <Col className="pl-0" sm={3}>
                                                                            <ul>
                                                                                <li><Link prefetch={true}  href={i?.section_data?.description} target={'_blank'}>{
                                                                                  reactHtmlParser(i?.section_data?.subtitle)
                                                                                }</Link></li>

                                                                            </ul>
                                                                        </Col>
                                                                        <Col className="pl-0" sm={2}>
                                                                            <ul>
                                                                                <li className={'number'}>
                                                                                    {
                                                                                        phoneNumbers?.map((e,index) => {
                                                                                            return (
                                                                                                <>
                                                                                                    <Link style={{display: 'block'}} prefetch={true}  key={index} href={`tel:${e}`}>{e}</Link>
                                                                                                </>
                                                                                            )
                                                                                        })

                                                                                    }
                                                                                </li>

                                                                            </ul>
                                                                        </Col>

                                                                        <Col className="pl-0 email pr-0" sm={2}>
                                                                            <ul >
                                                                                <li className={'email'}><a href={`mailto:${i?.section_data?.search_slug}`}>{i?.section_data?.search_slug}</a></li>
                                                                            </ul>
                                                                        </Col>
                                                                        <Col className={'pl-0 map-btn'} sm={2}>
                                                                            <div className="button-map">
                                                                                <p>Map</p>
                                                                                <span><BsChevronDown/></span>
                                                                            </div>
                                                                        </Col>
                                                                    </div>

                                                                </Accordion.Header>
                                                                <Accordion.Body>
                                                                    <div className="map">
                                                                      <div className={'map-body'}>
                                                                            {reactHtmlParser(i?.section_data?.extra_desc)}
                                                                        </div>
                                                                    </div>

                                                                </Accordion.Body>
                                                            </Accordion.Item>
                                                        )
                                                    })
                                                }

                                            </Accordion>
                                        }

                                    </Tab>
                                )
                            })
                        }

                    </Tabs>

                }

            </ThemeContainer>
        </StyledAddress>
    );
};
const StyledAddress = styled.section`
    background: ${softWhite};
    padding-top: 80px;
    padding-bottom: 200px;
    overflow: hidden;
    .address-cat-list {

        display: flex;
        margin-bottom: 60px !important;

        li {

            button {
                font-size: 16px;
                line-height: 24px;
                letter-spacing: -0.16px;
                font-weight: 400;
                color: ${text};
                background: white;
                border-radius: 20px;
                overflow: hidden;
                border: none;
                height: 40px;
                padding: 0 30px;

                &.active {
                    background-color: ${hover} !important;
                    color: ${white} !important;
                }

            }
        }
    }


    .accordion-item {
        margin-bottom: 30px;
        padding-bottom: 30px;
        border-bottom: 1px solid rgba(54, 50, 49, 0.1) !important;

        &:nth-last-child(1) {
            margin-bottom: 0;
        }
    }

    .nav-tabs {
        border: none;
        gap: 30px;
    }

    .accordion-header {
        position: relative;
        margin: 0;


        button {
            border: none;
            background-color: transparent;
            padding-left: 0;
            font-size: 16px;
            line-height: 24px;
            letter-spacing: -0.16px;
            font-weight: 400;
            text-transform: capitalize;
            width: 100%;
            text-align: left;
            transition: all .4s ease;

            .email {
                display: flex !important;
                white-space: inherit !important;
                word-break: break-word !important;

                a {
                    text-transform: none;
                }
            }

            .contact-numbers {
                h4 {
                    font-size: 24px;
                    line-height: 32px;
                    font-weight: 400;
                    color: #191919;

                }

                p {
                    font-size: 16px;
                    line-height: 24px;
                    letter-spacing: -0.16px;
                    font-weight: 400;
                    color: ${text};
                }

                ul {
                    margin-top: 5px;

                    li {

                        &.number {
                            a {
                                display: inline-flex;
                            }
                        }


                        a {
                            font-size: 16px;
                            line-height: 24px;
                            letter-spacing: -0.16px;
                            font-weight: 400;
                            color: ${text};
                        }

                        p {
                            font-size: 16px;
                            line-height: 24px;
                            letter-spacing: -0.16px;
                            font-weight: 400;
                            color: ${text};
                        }
                    }
                }
            }

            .map-btn {
                display: flex;
                justify-content: flex-end;
                gap: 20px;

                p {
                    color: ${white};
                }

                @media (max-width: 767px) {
                    justify-content: flex-start;
                }
            }

            &.collapsed {
                color: #1A1818;
                border-color: #1A1818;

                .button-map {
                    background: white;

                    p {
                        color: ${text};
                    }

                    svg {
                        fill: ${text};
                        transform: rotate(180deg);
                    }
                }

            }

            @media (max-width: 767px) {
                .col-sm-2, .col-sm-3 {
                    margin-bottom: 20px;

                    br {
                        display: none;
                    }
                }
            }
        }

        .button-map {
            //position: absolute;
            height: 40px;
            border-radius: 25px;
            color: #ffffff;
            background-color: ${hover};
            right: 0;
            align-items: center;
            justify-content: center;
            display: flex;
            padding: 0 25px;
            bottom: 0;
            gap: 5px;

            svg {
                font-size: 13px;
                z-index: 2;
                top: -2px;
                position: relative;
            }

        }

        &:hover {
            span {
                &:after {
                    height: 100%;
                    width: 100%;
                    opacity: 1;
                }
            }

            button {
                color: ${hover};
                border-color: ${hover};
            }
        }
    }

    .accordion-body {
        padding-top: 30px;

        p {
            width: 70%;
        }

        p, a {
            font-size: 16px;
            line-height: 24px;
            letter-spacing: -0.16px;
            font-weight: 400;
            color: ${text};
        }

        .contact-numbers {

            h4 {
                font-size: 20px;
                line-height: 28px;
                font-weight: 400;
                color: ${text};
                margin: 0 0 10px 0;
            }

            ul {
                li {
                    a {
                        cursor: pointer;
                        margin-bottom: 13px;
                        display: flex;
                        font-size: 16px;
                        line-height: 24px;
                        letter-spacing: -0.16px;
                        font-weight: 400;
                        color: ${text};

                        span {
                            font-size: 26px;
                            font-weight: bold;
                            line-height: 32px;
                            transition: .3s ease;
                        }

                        &:hover span {
                            color: #180E81;
                        }
                    }

                    &:nth-last-of-type(1) {
                        margin-bottom: 0;
                    }
                }
            }
        }

        .map {
            //margin-top: 45px;

            .map-body {
                position: relative;
                padding-top: calc(450 / 1170 * 100%);

                @media (max-width: 767px) {
                    padding-top: calc(210 / 345 * 100%);
                }

                iframe {
                    width: 100%;
                    height: 100%;
                    position: absolute;
                    inset: 0;
                }
            }

            iframe {
                width: 100%;
                height: 350px;
            }
        }
    }


    .address__form {

        .form-control {
            font-size: 16px;
            line-height: 22px;
            border: none;
            background-color: transparent;
            border-bottom: 1px solid black;
            border-radius: 0;
            padding-left: 0;
            padding-bottom: 20px;
            margin-bottom: 40px;

            &::placeholder {
                color: rgba(34, 31, 31, 0.5) !important;
                font-size: 16px;
                line-height: 22px;
                font-weight: 300;
            }
        }

        textarea {
            min-height: 90px;
            max-height: 90px;
            min-width: 100%;
            max-width: 100%;
            margin-bottom: 60px;
        }

        .divider {
            width: 100%;
            display: flex;
            justify-content: space-between;

            .form-control {
                width: calc(50% - 15px);
            }
        }

        &__title {
            margin-bottom: 60px;

            h5 {
                font-size: 16px;
                line-height: 22px;
                margin-bottom: 20px;
                font-weight: 600;
            }

            p {
                font-size: 26px;
                font-weight: bold;
                line-height: 32px;
            }
        }
    }

    @media (max-width: 992px) {
        .address__accordion {
            min-width: 100%;
        }

        .address__form {
            min-width: 100%;
            margin-top: 60px;
        }
    }

    @media (max-width: 992px) {

        .address__row {
            flex-direction: column-reverse;
        }

        .address__form {
            margin-top: 0;
            margin-bottom: 60px;
        }

        .contact-numbers {
            flex-wrap: wrap;
            flex-direction: column;
            gap: 20px;

            .map-btn {
                justify-content: flex-start !important;
            }

            > div {
                flex: 0 0 100%;
                max-width: 100%;
            }

            .col-sm-4 {
                min-width: 50%;

                &:nth-last-child(1) {
                    margin-top: 30px;
                    padding-left: 0;
                }
            }
        }
    }


    .address-cat-list {
        @media (max-width: 767px) {
            display: none;
        }
    }

    .address-filter__mobile {
        display: none;
        @media (max-width: 767px) {
            display: block;
            margin-bottom: 30px;
        }
    }

    .address-filter__mobile {
        padding: 0 15px;
    }


    @media(max-width: 767px){
        padding-bottom: 120px !important;
    }
    
    
`;


export default React.memo(Address);